import { Model } from 'app/model/backendmodel';
import { Folder, IModelAdapter } from 'shell-models-lib';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Metamodel } from 'app/model/base/model';

/**
 * Transforms a Folder entity back and forth between resource and model representations.
 */
@AdapterRegistry.adapter({
    model:  Metamodel.modelFor(Folder),
    adapts: {
        name: '*'
    }
})
export class FolderAdapter implements IModelAdapter<Folder, Model.IFolder> {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public toResource(named: Folder, ...other: any[]): Model.IFolder {
        let resource: { name?: string };

        if (named && named.name) {
            resource = {
                name: named.name
            };
        }

        return resource;
    }

    public toModel(resource: Model.IFolder, folderModel: Folder): Folder {
        if (!folderModel) {
            throw new TypeError('FolderAdapter: folderModel must be set');
        }

        const folderResource: { name?: string } = resource;

        if (folderResource && folderResource.name) {
            folderModel.name = folderResource.name;
        }

        return folderModel;
    }

    public async postToModel(value: Folder): Promise<void> {
        return;
    }
}
